// extracted by mini-css-extract-plugin
export default {"tarjetaContacto":"DatosGeneralesComponent_tarjetaContacto__6vl0v","circuloContacto":"DatosGeneralesComponent_circuloContacto__29c9E"};